import React, { useEffect, useState, useContext } from "react";
import "../../payment-style.scss";
import CheckoutArticleBoxLeft from "./CheckoutArticleBoxLeft";
import CheckoutArticleBoxRight from "./CheckoutArticleBoxRight";
import OrchestrationServiceApi from "../../Services/OrchestrationService";
import { billingActionEnum } from "../../Config/BillingType";
import DocBuilderService from "../../Services/DocBuilderService";
import { readCookie } from "../../Util/helper";
import PathHelper from "../../Util/PathHelper";
import { APP_NAVIGATION } from "../../Util/Constants";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import { useNavigate } from "react-router-dom";
import BillingDataContext from "../../Contexts/Billing.Context";
import PaymentFailedModal from "../../Components/Shared/PaymentFailedModal/PaymentFailedModal";
import { v4 as UUID4 } from "uuid";
import { trackLSEvents } from "../../Util/tracking-events";
type Props = {};

const Checkout = (props: Props) => {
  const [allValues, setAllValues] = useState<any>();
  const [paymentError, setPaymentError] = useState<any>();
  const [showLoader, setShowLoader] = useState("d-none");
  const handleLoaderPopupHide = (e:any) => setShowLoader(e);
  const navigate = useNavigate();
  const { state, dispatch } = useContext(BillingDataContext);
  let pathRedirect = PathHelper(APP_NAVIGATION.CHPG);
  const [showModal, setShowModal] = useState(false);
  let queryParams = new URLSearchParams(window.location.search);
  const callback = (fieldValue: any) => {
    setAllValues(fieldValue);
  };
  const callbackErrorMessage = (error: any) => {
    setPaymentError(error);
  };
  const doCheckOut = (data: any) => {
    OrchestrationServiceApi.checkoutProcess(data)
      .then((response: any) => {
        dispatch({
          type: billingActionEnum.CONFIRMATION,
          payload: { orderId: response },
        });
        if (response === 0) {
          callbackErrorMessage("PAYMENT DECLINED: please try again with different card or recheck the credentials.");
        }
        if (!!response) {
          const docid = readCookie("docid");
          if (docid) {
            console.log("generate pdf before process ..");
            DocBuilderService.GeneratePDFPath(docid, data.userGuid).then((docResponse: any) => {
              console.log(docResponse);
              // TO DO :: generate path before navigation
              //setShowLoader("d-none");
              navigate(pathRedirect.next);
              LogPaymentSuccessEvent(data.skuGuid, data.userGuid);
            });
          } else {
            console.log("navigation with out path generate ..");
            // default  flow without path generate
            //setShowLoader("d-none");
            navigate(pathRedirect.next);
            LogPaymentSuccessEvent(data.skuGuid, data.userGuid);
          }
        } else {
          if(queryParams.has("token")){
            queryParams.delete("token");
            window.history.pushState({}, "", queryParams.toString());
          }
          setShowLoader("d-none");
          PaymentFailureResponse(data.userGuid);
        }
      })
      .catch((err: any) => {
        if(queryParams.has("token")){
          queryParams.delete("token");
          window.history.pushState({}, "", queryParams.toString());
        }
        setShowLoader("d-none");
        PaymentFailureResponse(data.userGuid);
      });
  };
  const paymentSuccessResponse = (skuId: any) => {
    navigate(pathRedirect.next + "?s=" + skuId);
  };
  const LogPaymentSuccessEvent = (skuId: any, userguid: any) => {
    let eventData = {};
    trackLSEvents("paymentSuccess", eventData).then((response: any) => {
      if (!!response) {
        paymentSuccessResponse(skuId);
      } else {
        paymentSuccessResponse(skuId);
      }
    });
  };
  const PaymentFailureResponse = (userguid: any) => {
    let eventData = {};
    trackLSEvents("paymentFailure", eventData).then((response: any) => {
      handleLoaderPopupHide("d-none")
      setShowModal(true);
    });

    //setShowLoader("d-none");
    // //setIsShowError("d-block");
    // callbackErrorMessage("PAYMENT DECLINED: please try again with different card or recheck the credentials.")
  };

  useEffect(() => {
    let eventData = {};
    trackLSEvents("checkoutView", eventData).then((response: any) => {});

    window.scrollTo(0, 0);
  }, []);
  return (
    <>
     <style>
        {`
            .olark-button-focus-wrapper {
              display: none;
            }
          `}
      </style>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <section className="payment_section new-cc-page">
        <div className="container">
          <div className="row">
            {/* <h1 className="header float-left col-lg-12 text-center">
                            You&apos;re On The Last Step Before Receiving Your Document
                        </h1> */}
            <h1 className="header float-left col-lg-12 text-center">
              Almost there! Your Document Is Now Ready to Download
            </h1>
          </div>
          <p className="text-danger">{paymentError}</p>
          <div className="row">
            <div className="col-sm-12 col-md-6 article-box-left">
              <CheckoutArticleBoxLeft callBack={callback} paymentError={paymentError} doCheckOut={doCheckOut} handleLoaderPopupHide={handleLoaderPopupHide}/>
            </div>
            <div className="col-sm-12 col-md-6 article-box-right">
              {" "}
              <CheckoutArticleBoxRight
                fieldValues={allValues}
                callbackErrorMessage={callbackErrorMessage}
                doCheckOut={doCheckOut}
                handleLoaderPopupHide={handleLoaderPopupHide}
                queryParams={queryParams}
              />
            </div>
          </div>
        </div>
      </section>
      {showModal && <PaymentFailedModal show={showModal} onHide={() => setShowModal(false)} />}
    </>
  );
};
export default Checkout;
